// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/command.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_symbol } from "./symbol_pb.js";
import { file_vitesse_v1_plugin } from "./plugin_pb.js";
/**
 * Describes the file vitesse/v1/command.proto.
 */
export const file_vitesse_v1_command = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common, file_vitesse_v1_symbol, file_vitesse_v1_plugin]);
/**
 * Describes the message vitesse.v1.WriteSymbolEntry.
 * Use `create(WriteSymbolEntrySchema)` to create a new message.
 */
export const WriteSymbolEntrySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 0);
/**
 * Describes the message vitesse.v1.WriteSymbolsRequest.
 * Use `create(WriteSymbolsRequestSchema)` to create a new message.
 */
export const WriteSymbolsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 1);
/**
 * Describes the message vitesse.v1.WriteSymbolResult.
 * Use `create(WriteSymbolResultSchema)` to create a new message.
 */
export const WriteSymbolResultSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 2);
/**
 * Describes the message vitesse.v1.WriteSymbolsReply.
 * Use `create(WriteSymbolsReplySchema)` to create a new message.
 */
export const WriteSymbolsReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 3);
/**
 * Describes the message vitesse.v1.SetPollingPriorityRequest.
 * Use `create(SetPollingPriorityRequestSchema)` to create a new message.
 */
export const SetPollingPriorityRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 4);
/**
 * Describes the message vitesse.v1.PollingPriorityEntry.
 * Use `create(PollingPriorityEntrySchema)` to create a new message.
 */
export const PollingPriorityEntrySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 5);
/**
 * Describes the message vitesse.v1.SetPollingPriorityResult.
 * Use `create(SetPollingPriorityResultSchema)` to create a new message.
 */
export const SetPollingPriorityResultSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 6);
/**
 * Describes the message vitesse.v1.SetPollingPriorityReply.
 * Use `create(SetPollingPriorityReplySchema)` to create a new message.
 */
export const SetPollingPriorityReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 7);
/**
 * Describes the message vitesse.v1.SetSymbolLockRequest.
 * Use `create(SetSymbolLockRequestSchema)` to create a new message.
 */
export const SetSymbolLockRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 8);
/**
 * Describes the message vitesse.v1.SetSymbolLockResult.
 * Use `create(SetSymbolLockResultSchema)` to create a new message.
 */
export const SetSymbolLockResultSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 9);
/**
 * Describes the message vitesse.v1.SetSymbolLockReply.
 * Use `create(SetSymbolLockReplySchema)` to create a new message.
 */
export const SetSymbolLockReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 10);
/**
 * Describes the message vitesse.v1.ApplyLockToAllRequest.
 * Use `create(ApplyLockToAllRequestSchema)` to create a new message.
 */
export const ApplyLockToAllRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 11);
/**
 * Describes the message vitesse.v1.ApplyPriorityToAllRequest.
 * Use `create(ApplyPriorityToAllRequestSchema)` to create a new message.
 */
export const ApplyPriorityToAllRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 12);
/**
 * Describes the message vitesse.v1.ApplyToAllReply.
 * Use `create(ApplyToAllReplySchema)` to create a new message.
 */
export const ApplyToAllReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 13);
/**
 * Describes the message vitesse.v1.FieldError.
 * Use `create(FieldErrorSchema)` to create a new message.
 */
export const FieldErrorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 14);
/**
 * Describes the message vitesse.v1.AddControllerRequest.
 * Use `create(AddControllerRequestSchema)` to create a new message.
 */
export const AddControllerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 15);
/**
 * Describes the message vitesse.v1.AddControllerReply.
 * Use `create(AddControllerReplySchema)` to create a new message.
 */
export const AddControllerReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 16);
/**
 * Describes the message vitesse.v1.UpdateControllerRequest.
 * Use `create(UpdateControllerRequestSchema)` to create a new message.
 */
export const UpdateControllerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 17);
/**
 * Describes the message vitesse.v1.UpdateControllerReply.
 * Use `create(UpdateControllerReplySchema)` to create a new message.
 */
export const UpdateControllerReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 18);
/**
 * Describes the message vitesse.v1.RemoveControllerRequest.
 * Use `create(RemoveControllerRequestSchema)` to create a new message.
 */
export const RemoveControllerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 19);
/**
 * Describes the message vitesse.v1.RemoveControllerReply.
 * Use `create(RemoveControllerReplySchema)` to create a new message.
 */
export const RemoveControllerReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 20);
/**
 * Describes the message vitesse.v1.AddSymbolEntry.
 * Use `create(AddSymbolEntrySchema)` to create a new message.
 */
export const AddSymbolEntrySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 21);
/**
 * Describes the message vitesse.v1.AddSymbolsRequest.
 * Use `create(AddSymbolsRequestSchema)` to create a new message.
 */
export const AddSymbolsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 22);
/**
 * Describes the message vitesse.v1.AddSymbolResult.
 * Use `create(AddSymbolResultSchema)` to create a new message.
 */
export const AddSymbolResultSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 23);
/**
 * Describes the message vitesse.v1.AddSymbolsReply.
 * Use `create(AddSymbolsReplySchema)` to create a new message.
 */
export const AddSymbolsReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 24);
/**
 * Describes the message vitesse.v1.DeleteSymbolsRequest.
 * Use `create(DeleteSymbolsRequestSchema)` to create a new message.
 */
export const DeleteSymbolsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 25);
/**
 * Describes the message vitesse.v1.DeleteSymbolResult.
 * Use `create(DeleteSymbolResultSchema)` to create a new message.
 */
export const DeleteSymbolResultSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 26);
/**
 * Describes the message vitesse.v1.DeleteSymbolsReply.
 * Use `create(DeleteSymbolsReplySchema)` to create a new message.
 */
export const DeleteSymbolsReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 27);
/**
 * Describes the message vitesse.v1.PluginsWriteSymbolsRequest.
 * Use `create(PluginsWriteSymbolsRequestSchema)` to create a new message.
 */
export const PluginsWriteSymbolsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 28);
/**
 * Describes the message vitesse.v1.PluginsSetPollingPriorityRequest.
 * Use `create(PluginsSetPollingPriorityRequestSchema)` to create a new message.
 */
export const PluginsSetPollingPriorityRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 29);
/**
 * Describes the message vitesse.v1.PluginsSetSymbolLockRequest.
 * Use `create(PluginsSetSymbolLockRequestSchema)` to create a new message.
 */
export const PluginsSetSymbolLockRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 30);
/**
 * Describes the message vitesse.v1.PluginsApplyLockToAllRequest.
 * Use `create(PluginsApplyLockToAllRequestSchema)` to create a new message.
 */
export const PluginsApplyLockToAllRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 31);
/**
 * Describes the message vitesse.v1.PluginsApplyPriorityToAllRequest.
 * Use `create(PluginsApplyPriorityToAllRequestSchema)` to create a new message.
 */
export const PluginsApplyPriorityToAllRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 32);
/**
 * Describes the message vitesse.v1.PluginsAddControllerRequest.
 * Use `create(PluginsAddControllerRequestSchema)` to create a new message.
 */
export const PluginsAddControllerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 33);
/**
 * Describes the message vitesse.v1.PluginsUpdateControllerRequest.
 * Use `create(PluginsUpdateControllerRequestSchema)` to create a new message.
 */
export const PluginsUpdateControllerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 34);
/**
 * Describes the message vitesse.v1.PluginsRemoveControllerRequest.
 * Use `create(PluginsRemoveControllerRequestSchema)` to create a new message.
 */
export const PluginsRemoveControllerRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 35);
/**
 * Describes the message vitesse.v1.PluginsAddSymbolsRequest.
 * Use `create(PluginsAddSymbolsRequestSchema)` to create a new message.
 */
export const PluginsAddSymbolsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 36);
/**
 * Describes the message vitesse.v1.PluginsDeleteSymbolsRequest.
 * Use `create(PluginsDeleteSymbolsRequestSchema)` to create a new message.
 */
export const PluginsDeleteSymbolsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 37);
/**
 * Describes the message vitesse.v1.PluginsSubscribeRequest.
 * Use `create(PluginsSubscribeRequestSchema)` to create a new message.
 */
export const PluginsSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 38);
/**
 * Describes the message vitesse.v1.PluginEvent.
 * Use `create(PluginEventSchema)` to create a new message.
 */
export const PluginEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_command, 39);
/**
 * @generated from enum vitesse.v1.PluginEvent.Op
 */
export var PluginEvent_Op;
(function (PluginEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    PluginEvent_Op[PluginEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * descriptor present in `descriptor`
     *
     * @generated from enum value: OP_PUT = 1;
     */
    PluginEvent_Op[PluginEvent_Op["PUT"] = 1] = "PUT";
    /**
     * plugin gone; `descriptor` unset
     *
     * @generated from enum value: OP_DELETE = 2;
     */
    PluginEvent_Op[PluginEvent_Op["DELETE"] = 2] = "DELETE";
})(PluginEvent_Op || (PluginEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.PluginEvent.Op.
 */
export const PluginEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_command, 39, 0);
/**
 * Browser-facing service. Bridged by api-gateway:
 *
 *   Browser → api-gateway : Plugins.WriteSymbols (Connect-unary)
 *   api-gateway → NATS    : nc.Request("org.<org>.cmd.<gw>.plugins.<pid>.writeSymbols", req.inner)
 *   plugin → NATS         : reply with WriteSymbolsReply
 *
 * @generated from service vitesse.v1.Plugins
 */
export const Plugins = /*@__PURE__*/ serviceDesc(file_vitesse_v1_command, 0);
//# sourceMappingURL=command_pb.js.map